<template>
    <div class="burger" >
        <fa icon="bars" />
    </div>
</template>

<style scoped lang="scss">
@import "@/assets/vars.scss";
.burger {
    cursor: pointer;
    color: $primary;

    * { pointer-events: none; }
}
.burger:hover { color: $secondary; }
</style>
